import { useFormikContext } from 'formik';
import { ReleaseIdCard } from 'front-office/view-models/release-id-card';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { useState } from 'react';
import Form from './form';
import { Residence } from 'front-office/view-models/release-id-card/residence';

const ResidenceForm = (): React.ReactElement => {
  const formContext = useFormikContext<ReleaseIdCard>();

  const [open, setOpen] = useState(false);

  const onChangeResidence = useEventCallback(
    (key: keyof Residence, value: Residence[keyof Residence]) => {
      const newResidence = {
        ...formContext.values.residence,
        [key]: value,
      };

      formContext.setFieldValue('residence', newResidence);
    }
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-content"
        id="panel-person-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Residenza</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Form values={formContext.values.residence as Residence} onChange={onChangeResidence} />
      </AccordionDetails>
    </Accordion>
  );
};

ResidenceForm.displayName = 'Release id card form - residence component';

export default ResidenceForm;
